import { render, staticRenderFns } from "./GraduationList.vue?vue&type=template&id=f79567e0&scoped=true"
import script from "./GraduationList.vue?vue&type=script&lang=js"
export * from "./GraduationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79567e0",
  null
  
)

export default component.exports